<template>
  <section class="section section-shaped section-lg my-0">
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div class="text-muted text-center mb-3">
                <span>Inicio de Sesión</span>
              </div>
            </template>
            <template>
              <form role="form" @submit.prevent="login">
                <base-input
                  alternative
                  class="mb-3"
                  placeholder="Correo"
                  addon-left-icon="ni ni-email-83"
                  v-model="username"
                  required
                ></base-input>
                <base-input
                  alternative
                  type="password"
                  placeholder="Contraseña"
                  addon-left-icon="ni ni-lock-circle-open"
                  v-model="password"
                  required
                ></base-input>
                <!-- <base-checkbox>Recuerdame</base-checkbox> -->
                <div class="text-center">
                  <base-button
                    type="primary"
                    nativeType="submit"
                    @click="login"
                    class="my-4"
                    :disabled="loading"
                  >
                  <span v-if="!loading">Iniciar</span>
                  <span v-if="loading">Iniciando...</span>
                  </base-button>
                </div>
                <div class="text-center">
                  <router-link to="/">
                    <small>Volver al home</small>
                  </router-link>
                </div>
              </form>
              
              <base-alert type="default" v-if="errorMessage">
                {{errorMessage}}
              </base-alert>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <router-link to="/recuperar-clave" class="text-light"  style="display:none">
                <small>Olvidaste tu contraseña?</small>
              </router-link>
            </div>
            <div class="col-6 text-right">
              <router-link to="/registro" class="text-light">
                <small>Crear una nueva cuenta</small>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import { Auth } from "aws-amplify";
import { AmplifyEventBus } from "aws-amplify-vue";

export default {
  name: "Login",
  data() {
    return {
      username: null,
      password: null,
      errorMessage: null,
      user: null,
      loading: false,
      step: 0
    };
  },
  methods: {
    async login() {
      this.loading = true;
        this.errorMessage = null;
        let username = this.username.split('@');
        username = username[0];
        try {
          var user = await Auth.signIn(username, this.password);
          this.user = user;

          let currentUser = await Auth.currentUserInfo();
          console.log(user);

          if (user.challengeName == "NEW_PASSWORD_REQUIRED") {
            this.step = 1;
          } else if (!currentUser.attributes.email) {
            this.step = 2;
          } else if (!currentUser.attributes.email_verified) {
            this.step = 3;
          } else {
            this.$store.commit("setSignIn", user);
            this.$router.push("/historial-redenciones");
          }
        } catch (err) {
          console.log(err);
          switch (err.code) {
            case "UserNotFoundException":
              this.errorMessage = "El usuario no existe.";
              break;
            case "NotAuthorizedException":
              this.errorMessage = "Nombre de usuario o contraseña incorrectos.";
              break;
            case "UserNotConfirmedException":
              Auth.resendSignUp(this.username).then(()=>{
                console.log('Enviado');
              }).catch((err) =>{
                console.log(err);
              });
              this.errorMessage = "Por favor, confirme su correo electrónico antes de continuar"
          }
        }
        this.loading = false;
    },
    async updatePassword() {
      this.errorMessage = null;
      try {
        var change = await this.user.completeNewPasswordChallenge(
          this.new_password,
          Auth.currentAuthenticatedUser(),
          {
            onSuccess: async resp => {
              alert("Contraseña actualizada exitósamente");
              this.password = this.new_password;
              this.login();
            },
            onFailure: err => {
              this.errorMessage =
                "No se pudo actualizar su contraseña por favor verifique que cumple con los requisitos minimos";
            }
          }
        );
      } catch (err) {
        this.errorMessage = "Ocurrió un error al intentar actualizar los datos";
      }
    },
    async updateEmail() {
      this.errorMessage = null;
      try {
        await Auth.updateUserAttributes(this.user, {
          email: this.email
        });
        this.step = 3;
        alert("Su correo fue actualizado correctamente");
      } catch (err) {
        this.errorMessage =
          "Ocurrió un error intentando actualizar su correo, por favor verifíquelo e intente nuevamente";
      }
    },
    async confirmMail() {
      this.errorMessage = null;
      try {
        await Auth.verifyCurrentUserAttributeSubmit("email", this.email_code);
        this.login();
      } catch (err) {
        switch (err.code) {
          case "CodeMismatchException":
            this.errorMessage = "Codigo de verificación  incorrecto";
            break;
          default:
            this.errorMessage =
              "Ocurrió un error al intentar verificar el código";
            break;
        }
      }
    }
  }
};
</script>
<style>
</style>
